import "core-js/modules/es6.symbol";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.object.set-prototype-of";
import { createRef, createElement, Component } from 'react';
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

/* global Reflect, Promise */

var _extendStatics = function extendStatics(d, b) {
  _extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return _extendStatics(d, b);
};

function __extends(d, b) {
  _extendStatics(d, b);

  function __() {
    this.constructor = d;
  }

  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return _assign.apply(this, arguments);
};

function __rest(s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
}

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".styles_backgroundImageContainer__37Lq2 {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n}\n\n.styles_backgroundImagePlaceholder__34JD0 {\n  position: absolute;\n  z-index: 1;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background-position: center;\n  background-size: cover;\n}\n\n.styles_backgroundImageHd__tJ4b- {\n  position: absolute;\n  z-index: 2;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background-position: center;\n  background-size: cover;\n  opacity: 0;\n  transition: opacity 1s ease;\n}\n\n.styles_backgroundImageHdFadeIn__3XRSC {\n  opacity: 1;\n}\n";
var styles = {
  "backgroundImageContainer": "styles_backgroundImageContainer__37Lq2",
  "backgroundImagePlaceholder": "styles_backgroundImagePlaceholder__34JD0",
  "backgroundImageHd": "styles_backgroundImageHd__tJ4b-",
  "backgroundImageHdFadeIn": "styles_backgroundImageHdFadeIn__3XRSC"
};
styleInject(css);
/**
 * @class BackgroundImage
 */

var BackgroundImage =
/** @class */
function (_super) {
  __extends(BackgroundImage, _super);

  function BackgroundImage(props) {
    var _this = _super.call(this, props) || this;

    _this.hdImage = createRef();
    return _this;
  }

  BackgroundImage.prototype.componentDidMount = function () {
    var _this = this;

    var newImage = document.createElement("img");
    var hdImageRef = this.hdImage.current; // Using ! to remove undefined/null from type definition

    newImage.src = this.props.src;

    newImage.onload = function () {
      hdImageRef.setAttribute("style", "background-image: url('" + _this.props.src + "')");
      hdImageRef.classList.add("" + styles.backgroundImageHdFadeIn);
    };
  };

  BackgroundImage.prototype.render = function () {
    var _a = this.props,
        placeholder = _a.placeholder,
        className = _a.className,
        children = _a.children,
        rest = __rest(_a, ["placeholder", "className", "children"]);

    return createElement("div", _assign({
      className: styles.backgroundImageContainer + " " + (className ? className : "")
    }, rest), createElement("div", {
      className: styles.backgroundImageHd,
      ref: this.hdImage
    }), createElement("div", {
      className: styles.backgroundImagePlaceholder,
      style: {
        backgroundImage: "url('" + placeholder + "')"
      }
    }), children);
  };

  return BackgroundImage;
}(Component);

export default BackgroundImage;